module.exports = __webpack_public_path__ + "static/media/S2N9-1.26a1e659.svg";